import { render } from "./Product.vue?vue&type=template&id=3ad09e0c&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./custom-product.scss?vue&type=style&index=0&id=3ad09e0c&lang=scss&scoped=true"
import "./Product.vue?vue&type=style&index=1&id=3ad09e0c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad09e0c"]])

export default __exports__